interface Props {
  children: React.ReactNode;
}

const FieldsetFooterStatus: React.FC<Props> = ({ children }: Props) => {
  return <span className="flex-1 text-sm text-muted-foreground">{children}</span>;
};

export default FieldsetFooterStatus;
